// parse empty content JSON
 
const emptyContentEl = document.querySelector('#emptyWishlistContent')
let emptyContentJSON = ''

if (emptyContentEl) {
  emptyContentJSON = JSON.parse(emptyContentEl.innerHTML)
}

const templates = [
  {
    id: "wishlist-link",
    data: "wishlist",
    template: `
      <a href="{{ wishlist.url }}" class="wk-link wk-link--{{ wishlist.state }}" title="{{ locale.view_wishlist }}" aria-label="Wishlist">
        <div class="wk-icon wk-link__icon">{% include "wishlist-icon" %}</div>
        <span class="wk-link__label">{{ locale.wishlist }}</span>
        <span class="wk-link__count">{{ wishlist.item_count }}</span>
      </a>
    `,
  },
  {
    id: "wishlist-button",
    data: "product",
    events: {
      "click button[data-wk-add-product]": (event) => {
        event.preventDefault();
        event.stopPropagation();

        var productId = event.currentTarget.getAttribute('data-wk-add-product');
        var variantId = event.currentTarget.getAttribute('data-wk-variant');
        WishlistKing.toolkit.addProduct(productId, variantId);
      },
      "click button[data-wk-remove-product]": (event) => {
        event.preventDefault();
        event.stopPropagation();

        var productId = event.currentTarget.getAttribute('data-wk-remove-product');
        var variantId = event.currentTarget.getAttribute('data-wk-variant');
        
        WishlistKing.toolkit.removeProduct(productId, variantId);
      },
      "click button[data-wk-remove-item]": (event) => {
        event.preventDefault();
        event.stopPropagation();

        WishlistKing.toolkit.removeItem(
          event.currentTarget.getAttribute("data-wk-remove-item")
        );
      },
    },
    template: `
      {% if product.in_wishlist %}
        {% assign btn_text = locale.in_wishlist %}
        {% assign btn_title = locale.remove_from_wishlist %}
        {% assign btn_action = 'remove' %}
      {% else %}
        {% assign btn_text = locale.add_to_wishlist %}
        {% assign btn_title = locale.add_to_wishlist %}
        {% assign btn_action = 'add' %}
      {% endif %}

      {% assign scope = "product" %}
      {% assign targetId = product.id %}
      {% assign icon_name = "wishlist-icon" %}

      {% if itemId %}
      {% assign scope = "item" %}
      {% assign targetId = itemId %}
      {% assign icon_name = "remove-icon" %}
      {% endif %}

      <button type="button" class="wk-button wk-button--{{ btn_action }} {{ addClass }}" title="{{ btn_title }}" data-wk-{{ btn_action }}-{{ scope }}="{{ targetId }}" data-wk-variant="{{ product.variant }}">
        <div class="wk-icon wk-button__icon">{% include icon_name %}</div>
        <span class="wk-button__label">{{ btn_text }}</span>
      </button>
    `,
  },
  {
    id: "wishlist-button-floating",
    data: "product",
    template: `
      {% include "wishlist-button" addClass: "wk-button--floating" %}
    `,
  },
  {
    id: "wishlist-page",
    data: "wishlist",
    events: {
      "click a[data-wk-share]": (event) => {
        event.preventDefault();
        event.stopPropagation();

        WishlistKing.toolkit.requestWishlistSharing({
          wkShareService: event.currentTarget.getAttribute(
            "data-wk-share-service"
          ),
          wkShare: event.currentTarget.getAttribute("data-wk-share"),
          wkShareImage: event.currentTarget.getAttribute("data-wk-share-image"),
        });
      },
    },
    template: `
      <div class='wk-page {% if wishlist.read_only %}wk-page--shared{% endif %}'>
        {% if customer %}
          <aside class="account-sidebar">
            <ul class="account-sidebar-items">
                <li class="account-sidebar-item">
                    <i>
                      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                          <path d="M8.99929 1L1.23145 5.50656V12.4933L8.99929 17L16.7671 12.4933V5.50656L8.99929 1ZM15.7431 5.69068L13.2714 7.12451L6.49765 3.22927L8.99929 1.77819L15.7431 5.69068ZM8.99929 9.60372L2.25545 5.69068L5.18699 3.98966L11.9308 7.90233L8.99929 9.60372ZM1.93792 6.28457L8.64616 10.1768V16.0167L1.93792 12.1248V6.28457ZM9.35243 16.0169V10.177L12.1769 8.53813V10.3237L13.5893 9.33097V7.71914L16.0607 6.28494V12.1252L9.35243 16.0169Z" fill="black"/>
                      </svg>
                    </i>
                    <a href="/account/orders">
                        Order History
                    </a>
                </li>
                <li class="account-sidebar-item">
                    <i>
                      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                          <path d="M13.5418 1.44434H3.5862C2.99775 1.44434 2.51953 1.92256 2.51953 2.511V14.5999C2.51953 15.1883 2.99775 15.6666 3.5862 15.6666H9.9862V16.1999C9.9862 16.8861 10.5444 17.4443 11.2306 17.4443C11.9169 17.4443 12.4751 16.8861 12.4751 16.1999V15.6666H13.5418C14.1302 15.6666 14.6084 15.1883 14.6084 14.5999V2.511C14.6084 1.92256 14.1302 1.44434 13.5418 1.44434ZM3.23064 14.5999V2.511C3.23064 2.31545 3.39064 2.15545 3.5862 2.15545H4.29731V14.9554H3.5862C3.39064 14.9554 3.23064 14.7954 3.23064 14.5999ZM11.764 16.1999C11.764 16.4932 11.524 16.7332 11.2306 16.7332C10.9373 16.7332 10.6973 16.4932 10.6973 16.1999V15.6666H11.764V16.1999ZM13.8973 14.5999C13.8973 14.7954 13.7373 14.9554 13.5418 14.9554H12.1195H10.3418H5.00842V2.15545H13.5418C13.7373 2.15545 13.8973 2.31545 13.8973 2.511V14.5999ZM12.8306 4.99989C12.8306 5.19545 12.6706 5.35545 12.4751 5.35545H6.43064C6.23509 5.35545 6.07509 5.19545 6.07509 4.99989C6.07509 4.80434 6.23509 4.64434 6.43064 4.64434H12.4751C12.6706 4.64434 12.8306 4.80434 12.8306 4.99989ZM12.8306 6.77767C12.8306 6.97323 12.6706 7.13322 12.4751 7.13322H6.43064C6.23509 7.13322 6.07509 6.97323 6.07509 6.77767C6.07509 6.58211 6.23509 6.42211 6.43064 6.42211H12.4751C12.6706 6.42211 12.8306 6.58211 12.8306 6.77767Z" fill="black"/>
                      </svg>
                    </i>
                    <a href="/account/addresses">
                        Address Book
                    </a>
                </li>
                <li class="account-sidebar-item">
                    <i>
                      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                          <path d="M8.58857 1C10.5458 1 12.1604 2.61468 12.1604 4.57187C12.1604 6.38226 10.7904 7.89908 8.98001 8.0948V12.841H11.5243V13.6728H8.98001V14.6024H9.86074V15.4343H8.98001V16.1682H11.5243V17H8.1482V8.0948C6.38673 7.89908 4.96777 6.38226 4.96777 4.57187C4.96777 2.61468 6.58245 1 8.53964 1H8.58857ZM8.58857 1.8318C7.07175 1.8318 5.84851 3.05505 5.84851 4.57187C5.84851 6.08869 7.07175 7.31193 8.58857 7.31193C10.1054 7.31193 11.3286 6.08869 11.3286 4.57187C11.3286 3.05505 10.1054 1.8318 8.58857 1.8318Z" fill="black"/>
                      </svg>
                    </i>
                    <a href="/account/login?return_url=%2Faccount#recover">
                        Password
                    </a>
                </li>
                <li class="account-sidebar-item">
                    <i>
                      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                          <path d="M17.7537 7.52061C15.4734 7.04947 13.7019 5.25913 13.2308 2.9788C13.2119 2.86572 13.1177 2.79034 12.9858 2.79034C12.8727 2.79034 12.7785 2.86572 12.7408 2.9788C12.2696 5.25913 10.4793 7.04947 8.21781 7.52061C8.10473 7.53946 8.02935 7.63369 8.02935 7.76561C8.02935 7.87868 8.10473 7.97291 8.21781 8.0106C10.4981 8.48174 12.2696 10.2721 12.7408 12.5336C12.7596 12.6466 12.8538 12.722 12.9858 12.722C13.0988 12.722 13.1931 12.6466 13.2308 12.5336C13.7019 10.2532 15.4922 8.48174 17.7537 8.0106C17.8668 7.99175 17.9422 7.89753 17.9422 7.76561C17.9422 7.63369 17.8668 7.53946 17.7537 7.52061Z" fill="black"/>
                          <path d="M10.1589 12.8351C8.33088 12.4582 6.89861 11.0259 6.52169 9.17903C6.50285 9.08481 6.42746 9.02827 6.33324 9.02827C6.23901 9.02827 6.16362 9.08481 6.14478 9.17903C5.76786 11.0259 4.33559 12.4582 2.50756 12.8351C2.41333 12.8539 2.35679 12.9293 2.35679 13.0236C2.35679 13.1178 2.41333 13.1932 2.50756 13.212C4.33559 13.5889 5.76786 15.0212 6.14478 16.8492C6.16362 16.9435 6.23901 17 6.33324 17C6.42746 17 6.50285 16.9435 6.52169 16.8492C6.89861 15.0212 8.33088 13.5889 10.1589 13.212C10.2531 13.1932 10.3097 13.1178 10.3097 13.0236C10.3097 12.9293 10.2531 12.8539 10.1589 12.8351Z" fill="black"/>
                          <path d="M3.65715 8.51943C3.69484 8.63251 3.78907 8.70789 3.90214 8.70789C4.01521 8.70789 4.12829 8.63251 4.14713 8.51943C4.54289 6.84217 5.89978 5.50412 7.55821 5.10836C7.67128 5.07067 7.74666 4.97644 7.74666 4.86337C7.74666 4.75029 7.67128 4.63722 7.55821 4.61837C5.86209 4.20377 4.54289 2.88457 4.14713 1.18846C4.12829 1.07538 4.01521 1 3.90214 1C3.78907 1 3.67599 1.07538 3.65715 1.18846C3.24254 2.88457 1.94219 4.20377 0.246074 4.61837C0.133 4.65607 0.0576172 4.75029 0.0576172 4.86337C0.0576172 4.97644 0.133 5.08952 0.246074 5.10836C1.9045 5.50412 3.24254 6.84217 3.65715 8.51943Z" fill="black"/>
                      </svg>
                    </i>
                    <a href="/account">
                        My Points & Rewards
                    </a>
                </li>
                <li class="account-sidebar-item active">
                    <i>
                      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M5.28484 1.00655C6.67934 1.0759 8.06183 1.69701 8.99637 2.90834C12.0205 -1.00676 19.5823 1.27792 17.4778 8.15241C16.0984 12.657 12.212 15.0683 9.73582 16.6045C8.88557 17.1322 9.10717 17.1314 8.2569 16.6045C5.78075 15.0684 1.89343 12.657 0.514878 8.15241C-0.413775 5.11839 0.493771 2.49153 2.97135 1.42037C3.69422 1.10755 4.49246 0.967344 5.28463 1.00655H5.28484Z" fill="black"/>
                      </svg>
                    </i>
                    <a href="/pages/wishlist">
                        My Wishlist
                    </a>
                </li>
                <li class="account-sidebar-item">
                    <i>
                      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                          <path d="M9 16C7.14348 16 5.36301 15.2625 4.05025 13.9497C2.7375 12.637 2 10.8565 2 9C2 7.14348 2.7375 5.36301 4.05025 4.05025C5.36301 2.7375 7.14348 2 9 2C10.8565 2 12.637 2.7375 13.9497 4.05025C15.2625 5.36301 16 7.14348 16 9C16 10.8565 15.2625 12.637 13.9497 13.9497C12.637 15.2625 10.8565 16 9 16ZM9 17C11.1217 17 13.1566 16.1571 14.6569 14.6569C16.1571 13.1566 17 11.1217 17 9C17 6.87827 16.1571 4.84344 14.6569 3.34315C13.1566 1.84285 11.1217 1 9 1C6.87827 1 4.84344 1.84285 3.34315 3.34315C1.84285 4.84344 1 6.87827 1 9C1 11.1217 1.84285 13.1566 3.34315 14.6569C4.84344 16.1571 6.87827 17 9 17Z" fill="#4A4A4A"/>
                          <path d="M5.646 5.646C5.69245 5.59944 5.74762 5.56249 5.80837 5.53729C5.86911 5.51208 5.93423 5.49911 6 5.49911C6.06577 5.49911 6.13089 5.51208 6.19163 5.53729C6.25238 5.56249 6.30755 5.59944 6.354 5.646L9 8.293L11.646 5.646C11.6925 5.59951 11.7477 5.56264 11.8084 5.53748C11.8692 5.51232 11.9343 5.49937 12 5.49937C12.0657 5.49937 12.1308 5.51232 12.1916 5.53748C12.2523 5.56264 12.3075 5.59951 12.354 5.646C12.4005 5.69249 12.4374 5.74768 12.4625 5.80842C12.4877 5.86916 12.5006 5.93426 12.5006 6C12.5006 6.06574 12.4877 6.13084 12.4625 6.19158C12.4374 6.25232 12.4005 6.30751 12.354 6.354L9.707 9L12.354 11.646C12.4005 11.6925 12.4374 11.7477 12.4625 11.8084C12.4877 11.8692 12.5006 11.9343 12.5006 12C12.5006 12.0657 12.4877 12.1308 12.4625 12.1916C12.4374 12.2523 12.4005 12.3075 12.354 12.354C12.3075 12.4005 12.2523 12.4374 12.1916 12.4625C12.1308 12.4877 12.0657 12.5006 12 12.5006C11.9343 12.5006 11.8692 12.4877 11.8084 12.4625C11.7477 12.4374 11.6925 12.4005 11.646 12.354L9 9.707L6.354 12.354C6.30751 12.4005 6.25232 12.4374 6.19158 12.4625C6.13084 12.4877 6.06574 12.5006 6 12.5006C5.93426 12.5006 5.86916 12.4877 5.80842 12.4625C5.74768 12.4374 5.69249 12.4005 5.646 12.354C5.59951 12.3075 5.56264 12.2523 5.53748 12.1916C5.51232 12.1308 5.49937 12.0657 5.49937 12C5.49937 11.9343 5.51232 11.8692 5.53748 11.8084C5.56264 11.7477 5.59951 11.6925 5.646 11.646L8.293 9L5.646 6.354C5.59944 6.30755 5.56249 6.25238 5.53729 6.19163C5.51208 6.13089 5.49911 6.06577 5.49911 6C5.49911 5.93423 5.51208 5.86911 5.53729 5.80837C5.56249 5.74762 5.59944 5.69245 5.646 5.646Z" fill="#4A4A4A"/>
                      </svg>
                    </i>
                    <a href="/account/logout">
                        Log Out
                    </a>
                </li>
            </ul>
          </aside>
        {% endif %}

        <div class="wk-wrapper">
          <h2 class="account-header">
            My Wishlist
          </h2>
          <p class="account-subheader">
            Save and share your favorites to your Wishlist  
          </p>
          {% if wishlist.item_count == 0 %}
            <div class="wk-note wk-note__list-empty">
              <p>{{ locale.wishlist_empty_note }}</p>
            </div>
            <div class="wk-cta">
              <a class="cta_link" href="${emptyContentJSON.emptyLink}">
                <button class="cta cta--secondary cta_color cta_bg btn_border">
                  <span style="color:secondary">
                    <span style="color:#111111">${emptyContentJSON.emptyText}</span>
                  </span>
                </button>
              </a>
            </div>
          {% else %}
            {% if customer_accounts_enabled and customer == null and wishlist.read_only == false %}
              <div class="wk-note wk-note__login">
                <p>{{ locale.login_or_signup_note }}</p>
              </div>
            {% endif %}
            <div>
              <div class="wk-grid">
                {% assign item_count = 0 %}
                {% assign products = wishlist.products | reverse %}
                {% for product in products %}
                  {% assign item_count = item_count | plus: 1 %}
                  {% unless limit and item_count > limit %}
                    {% assign hide_default_title = false %}
                    {% if product.variants.length == 1 and product.variants[0].title contains 'Default' %}
                      {% assign hide_default_title = true %}
                    {% endif %}
                    {% assign variant = product.selected_or_first_available_variant %}
                    {% if variant.price < variant.compare_at_price %}
                      {% assign onsale = true %}
                    {% else %}
                      {% assign onsale = false %}
                    {% endif %}
                    <div>
                      <div class="wk-grid__item {% if onsale %}wk-product--sale{% endif %}" data-wk-item="{{ product.wishlist_item_id }}">
                        {% unless wishlist.read_only %}
                          {% include "wishlist-button-floating" itemId: product.wishlist_item_id %}
                        {% else %}
                          {% include "wishlist-button-floating" product: product %}
                        {% endunless %}
                        <a href="{{ product | variant_url }}" class="wk-product-image" title="{{ locale.view_product }}" style="background-image: url({{ product | variant_img_url: '1000x' }})"></a>
                        <div class="wk-product-info">
                          <a class="wk-product-title" href="{{ product | variant_url }}">
                            {{ product.title }}
                          </a>
                          <div class="wk-product-price">
                            <span class="wk-product-price--current">{{ variant.price | money_with_currency | remove: "USD" }}</span>
                            <span class="wk-product-price--compare">{{ variant.compare_at_price | money_with_currency | remove: "USD" }}</span>
                          </div>
                        </div>
                        {% include "wishlist-product-form" %}
                      </div>
                    </div>
                  {% endunless %}
                {% endfor %}
              </div>
            </div>
            {% comment %}
            {% include "wishlist-button-bulk-add-to-cart" %}
            {% endcomment %}
            {% comment %}
            {% unless wishlist.read_only %}
              {% include "wishlist-button-clear" %}
            {% endunless %}
            {% endcomment %}
            {% unless wishlist.read_only %}
              <div class="wk-sharing">
                <h4 class="wk-title">{{ locale.share_wishlist }}</h4>
                <ul class="wk-sharing__list">
                  <li class="wk-sharing__list-item">{% include "wishlist-share-button-fb" %}</li>
                  <li class="wk-sharing__list-item">{% include "wishlist-share-button-twitter" %}</li>
                  <li class="wk-sharing__list-item">{% include "wishlist-share-button-email" %}</li>
                  <li class="wk-sharing__list-item">{% include "wishlist-share-button-link" %}</li>
                  <li class="wk-sharing__list-item">{% include "wishlist-share-button-whatsapp" %}</li>
                  {% comment %}<li class="wk-sharing__list-item">{% include "wishlist-share-button-contact" %}</li>{% endcomment %}
                </ul>
                <div class="wk-sharing__link wk-sharing__link--hidden"><span class="wk-sharing__link-text"></span><button class="wk-sharing__link__copy-button" data-clipboard-target=".wk-sharing__link-text">{{ locale.copy_share_link }}</button></div>
              </div>
            {% endunless %}
          {% endif %}
        </div>
      </div>
    `,
  },
  {
    id: "wishlist-product-form",
    events: {
      "render .wk-product-form": (form) => {
        const container = form.closest("[data-wk-item]");
        const itemId = container.getAttribute("data-wk-item");
        WishlistKing.toolkit.getItem(itemId).then((product) => {
          WishlistKing.toolkit.initProductForm(form, product, {
            // NOTE: Uncomment to override default option change
            // onOptionChange: (event) => {
            //   console.log(event.dataset);
            // },
            // NOTE: Uncomment to override default form submit
            // onFormSubmit: (event) => {
            //   event.preventDefault();
            //   event.stopPropagation();
            // },
          });
        });
      },
    },
    template: `
      <form class="wk-product-form" action="/cart/add" method="post">
        {% assign current_variant = product.selected_or_first_available_variant %}
        <div class="wk-product-form__options">
          <input name="id" value="{{ current_variant.id }}" type="hidden">
          {% unless product.has_only_default_variant %}
            {% for option in product.options_with_values %}
              <div class="wk-product-form__option">
                <label class="wk-product-form__option__label" for="Option{{ option.position }}">
                  {{ option.name }}
                </label>
                <select class="wk-product-form__option__select" name="options[{{ option.name | escape }}]">
                  {% for value in option.values %}
                    <option value="{{ value | escape }}" {% if option.selected_value == value %}selected="selected"{% endif %} {% if option.soldout_values contains value %}disabled{% endif %}>
                      {{ value }}
                    </option>
                  {% endfor %}
                </select>
              </div>
            {% endfor %}
          {% endunless %}
          {% comment %}
          <div class="wk-product-form__quantity">
            <label class="wk-product-form__quantity__label" for="Quantity">{{ locale.quantity }}</label>
            <input class="wk-product-form__quantity__input" type="number" name="quantity" value="1" min="1">
          </div>
          {% endcomment %}
        </div>
        <button type="submit" class="wk-product-form__submit" data-wk-add-to-cart="{{ product.wishlist_item_id }}" {% unless current_variant.available %}disabled{% endunless %}>
          {% if current_variant.available %}{{ locale.add_to_cart }}{% else %}{{ locale.sold_out }}{% endif %}
        </button>
      </form>
    `,
  },
  {
    id: "wishlist-page-shared",
    data: "shared_wishlist",
    template: `
      {% assign wishlist = shared_wishlist %}
      {% include "wishlist-page" with wishlist %}
    `,
  },
  {
    id: "wishlist-button-bulk-add-to-cart",
    data: "wishlist",
    events: {
      "click button[data-wk-bulk-add-to-cart]": (event) => {
        WishlistKing.toolkit.requestAddAllToCart(
          event.currentTarget.getAttribute("data-wk-bulk-add-to-cart")
        );
      },
    },
    template: `
      {% assign btn_text = locale.add_all_to_cart %}
      {% assign btn_title = locale.add_all_to_cart %}

      <button type="button" class="wk-button-bulk-add-to-cart" title="{{ btn_title }}" data-wk-bulk-add-to-cart="{{ wishlist.permaId }}">
        <span class="wk-label">{{ btn_text }}</span>
      </button>
    `,
  },
  {
    id: "wishlist-button-clear",
    data: "wishlist",
    events: {
      "click button[data-wk-clear-wishlist]": (event) => {
        WishlistKing.toolkit.clear(
          event.currentTarget.getAttribute("data-wk-clear-wishlist")
        );
      },
    },
    template: `
      {% assign btn_text = locale.clear_wishlist %}
      {% assign btn_title = locale.clear_wishlist %}

      <button type="button" class="wk-button-wishlist-clear" title="{{ btn_title }}" data-wk-clear-wishlist="{{ wishlist.permaId }}">
        <span class="wk-label">{{ btn_text }}</span>
      </button>
    `,
  },
  {
    id: "wishlist-icon",
    template: `
      <svg class="wk-icon__svg" width="100%" height="100%" viewBox="0 0 64 64" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <path vector-effect="non-scaling-stroke" d="M32.012,59.616c-1.119-.521-2.365-1.141-3.707-1.859a79.264,79.264,0,0,1-11.694-7.614C6.316,42,.266,32.6.254,22.076,0.244,12.358,7.871,4.506,17.232,4.5a16.661,16.661,0,0,1,11.891,4.99l2.837,2.889,2.827-2.9a16.639,16.639,0,0,1,11.874-5.02h0c9.368-.01,17.008,7.815,17.021,17.539,0.015,10.533-6.022,19.96-16.312,28.128a79.314,79.314,0,0,1-11.661,7.63C34.369,58.472,33.127,59.094,32.012,59.616Z"/>
      </svg>
    `,
  },
  {
    id: "remove-icon",
    template: `
      <svg class="wk-icon__svg" width="100%" height="100%" viewBox="0 0 64 64" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <path vector-effect="non-scaling-stroke" d="M0.309,0.309a0.9,0.9,0,0,1,1.268,0L63.691,62.423a0.9,0.9,0,0,1-1.268,1.268L0.309,1.577A0.9,0.9,0,0,1,.309.309Z"/>
        <path vector-effect="non-scaling-stroke" d="M63.691,0.309a0.9,0.9,0,0,1,0,1.268L1.577,63.691A0.9,0.9,0,0,1,.309,62.423L62.423,0.309A0.9,0.9,0,0,1,63.691.309Z"/>
      </svg>
    `,
  },
  {
    id: "wishlist-share-button-fb",
    data: "wishlist",
    template: `
      <a href="#" class="wk-share-button" title="{{ locale.share_on_facebook }}" data-wk-share-service="facebook" data-wk-share="{{ wishlist.permaId }}">
        <svg version="1.1" x="0px" y="0px" width="100%" height="100%" viewBox="0 0 24 24">
          <path fill="currentColor" d="M18.768,7.465H14.5V5.56c0-0.896,0.594-1.105,1.012-1.105s2.988,0,2.988,0V0.513L14.171,0.5C10.244,0.5,9.5,3.438,9.5,5.32 v2.145h-3v4h3c0,5.212,0,12,0,12h5c0,0,0-6.85,0-12h3.851L18.768,7.465z"/>
        </svg>
      </a>
    `,
  },
  {
    id: "wishlist-share-button-twitter",
    data: "wishlist",
    template: `
      <a href="#" class="wk-share-button" title="{{ locale.share_on_twitter }}" data-wk-share-service="twitter" data-wk-share="{{ wishlist.permaId }}">
        <svg version="1.1" x="0px" y="0px" width="100%" height="100%" viewBox="0 0 24 24">
        <path fill="currentColor" d="M23.444,4.834c-0.814,0.363-1.5,0.375-2.228,0.016c0.938-0.562,0.981-0.957,1.32-2.019c-0.878,0.521-1.851,0.9-2.886,1.104 C18.823,3.053,17.642,2.5,16.335,2.5c-2.51,0-4.544,2.036-4.544,4.544c0,0.356,0.04,0.703,0.117,1.036 C8.132,7.891,4.783,6.082,2.542,3.332C2.151,4.003,1.927,4.784,1.927,5.617c0,1.577,0.803,2.967,2.021,3.782 C3.203,9.375,2.503,9.171,1.891,8.831C1.89,8.85,1.89,8.868,1.89,8.888c0,2.202,1.566,4.038,3.646,4.456 c-0.666,0.181-1.368,0.209-2.053,0.079c0.579,1.804,2.257,3.118,4.245,3.155C5.783,18.102,3.372,18.737,1,18.459 C3.012,19.748,5.399,20.5,7.966,20.5c8.358,0,12.928-6.924,12.928-12.929c0-0.198-0.003-0.393-0.012-0.588 C21.769,6.343,22.835,5.746,23.444,4.834z"/>
        </svg>
      </a>
    `,
  },
  {
    id: "wishlist-share-button-whatsapp",
    data: "wishlist",
    template: `
      <a href="#" class="wk-share-button" title="{{ locale.share_with_whatsapp }}" data-wk-share-service="whatsapp" data-wk-share="{{ wishlist.permaId }}">
        <svg xmlns="https://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24">
          <path fill="currentColor" stroke="none" d="M20.1,3.9C17.9,1.7,15,0.5,12,0.5C5.8,0.5,0.7,5.6,0.7,11.9c0,2,0.5,3.9,1.5,5.6l-1.6,5.9l6-1.6c1.6,0.9,3.5,1.3,5.4,1.3l0,0l0,0c6.3,0,11.4-5.1,11.4-11.4C23.3,8.9,22.2,6,20.1,3.9z M12,21.4L12,21.4c-1.7,0-3.3-0.5-4.8-1.3l-0.4-0.2l-3.5,1l1-3.4L4,17c-1-1.5-1.4-3.2-1.4-5.1c0-5.2,4.2-9.4,9.4-9.4c2.5,0,4.9,1,6.7,2.8c1.8,1.8,2.8,4.2,2.8,6.7C21.4,17.2,17.2,21.4,12,21.4z M17.1,14.3c-0.3-0.1-1.7-0.9-1.9-1c-0.3-0.1-0.5-0.1-0.7,0.1c-0.2,0.3-0.8,1-0.9,1.1c-0.2,0.2-0.3,0.2-0.6,0.1c-0.3-0.1-1.2-0.5-2.3-1.4c-0.9-0.8-1.4-1.7-1.6-2c-0.2-0.3,0-0.5,0.1-0.6s0.3-0.3,0.4-0.5c0.2-0.1,0.3-0.3,0.4-0.5c0.1-0.2,0-0.4,0-0.5c0-0.1-0.7-1.5-1-2.1C8.9,6.6,8.6,6.7,8.5,6.7c-0.2,0-0.4,0-0.6,0S7.5,6.8,7.2,7c-0.3,0.3-1,1-1,2.4s1,2.8,1.1,3c0.1,0.2,2,3.1,4.9,4.3c0.7,0.3,1.2,0.5,1.6,0.6c0.7,0.2,1.3,0.2,1.8,0.1c0.6-0.1,1.7-0.7,1.9-1.3c0.2-0.7,0.2-1.2,0.2-1.3C17.6,14.5,17.4,14.4,17.1,14.3z"/>
        </svg>
      </a>
    `,
  },
  {
    id: "wishlist-share-button-email",
    data: "wishlist",
    template: `
      <a href="#" class="wk-share-button" title="{{ locale.share_by_email }}" data-wk-share-service="email" data-wk-share="{{ wishlist.permaId }}">
        <svg version="1.1" x="0px" y="0px" width="100%" height="100%" viewBox="0 0 24 24"">
          <path fill="currentColor" d="M22,4H2C0.897,4,0,4.897,0,6v12c0,1.103,0.897,2,2,2h20c1.103,0,2-0.897,2-2V6C24,4.897,23.103,4,22,4z M7.248,14.434 l-3.5,2C3.67,16.479,3.584,16.5,3.5,16.5c-0.174,0-0.342-0.09-0.435-0.252c-0.137-0.239-0.054-0.545,0.186-0.682l3.5-2 c0.24-0.137,0.545-0.054,0.682,0.186C7.571,13.992,7.488,14.297,7.248,14.434z M12,14.5c-0.094,0-0.189-0.026-0.271-0.08l-8.5-5.5 C2.997,8.77,2.93,8.46,3.081,8.229c0.15-0.23,0.459-0.298,0.691-0.147L12,13.405l8.229-5.324c0.232-0.15,0.542-0.084,0.691,0.147 c0.15,0.232,0.083,0.542-0.148,0.691l-8.5,5.5C12.189,14.474,12.095,14.5,12,14.5z M20.934,16.248 C20.842,16.41,20.673,16.5,20.5,16.5c-0.084,0-0.169-0.021-0.248-0.065l-3.5-2c-0.24-0.137-0.323-0.442-0.186-0.682 s0.443-0.322,0.682-0.186l3.5,2C20.988,15.703,21.071,16.009,20.934,16.248z"/>
        </svg>
      </a>
    `,
  },
  {
    id: "wishlist-share-button-link",
    data: "wishlist",
    template: `
      <a href="#" class="wk-share-button" title="{{ locale.get_link }}" data-wk-share-service="link" data-wk-share="{{ wishlist.permaId }}">
        <svg xmlns='https://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 512 512'>
          <path fill="currentColor" d='M459.654,233.373l-90.531,90.5c-49.969,50-131.031,50-181,0c-7.875-7.844-14.031-16.688-19.438-25.813
            l42.063-42.063c2-2.016,4.469-3.172,6.828-4.531c2.906,9.938,7.984,19.344,15.797,27.156c24.953,24.969,65.563,24.938,90.5,0
            l90.5-90.5c24.969-24.969,24.969-65.563,0-90.516c-24.938-24.953-65.531-24.953-90.5,0l-32.188,32.219
            c-26.109-10.172-54.25-12.906-81.641-8.891l68.578-68.578c50-49.984,131.031-49.984,181.031,0
            C509.623,102.342,509.623,183.389,459.654,233.373z M220.326,382.186l-32.203,32.219c-24.953,24.938-65.563,24.938-90.516,0
            c-24.953-24.969-24.953-65.563,0-90.531l90.516-90.5c24.969-24.969,65.547-24.969,90.5,0c7.797,7.797,12.875,17.203,15.813,27.125
            c2.375-1.375,4.813-2.5,6.813-4.5l42.063-42.047c-5.375-9.156-11.563-17.969-19.438-25.828c-49.969-49.984-131.031-49.984-181.016,0
            l-90.5,90.5c-49.984,50-49.984,131.031,0,181.031c49.984,49.969,131.031,49.969,181.016,0l68.594-68.594
            C274.561,395.092,246.42,392.342,220.326,382.186z'/>
        </svg>
      </a>
    `,
  },
  {
    id: "wishlist-share-button-contact",
    data: "wishlist",
    template: `
      <a href="#" class="wk-share-button" title="{{ locale.send_to_customer_service }}" data-wk-share-service="contact" data-wk-share="{{ wishlist.permaId }}">
        <svg width="100%" height="100%" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path fill="currentColor" d="M19 2H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h4l3 3 3-3h4c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-6 16h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 11.9 13 12.5 13 14h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z"/>
        </svg>
      </a>
    `,
  },
];

export default templates;
